import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "base-tooltip" }

import { ref, computed } from "vue";
import * as tooltip from "@zag-js/tooltip";
import { normalizeProps, useMachine } from "@zag-js/vue";
import { bsonId } from "@/common/utils/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-tooltip',
  props: {
    disabled: { type: Boolean },
    position: {}
  },
  setup(__props: any) {



const [state, send] = useMachine(
  tooltip.machine({
    id: bsonId(),
    positioning: {
      placement: "bottom",
    },
  })
);
const api = computed(() => tooltip.connect(state.value, send, normalizeProps));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _mergeProps({ ref: "ref" }, api.value.triggerProps, {
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_unref(send)('OPEN'))),
      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_unref(send)('CLOSE')))
    }), [
      _renderSlot(_ctx.$slots, "trigger")
    ], 16),
    (!__props.disabled && _ctx.$slots.tooltip)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (api.value.open)
            ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, api.value.positionerProps)), [
                _createElementVNode("div", _normalizeProps(_guardReactiveProps(api.value.contentProps)), [
                  _renderSlot(_ctx.$slots, "tooltip")
                ], 16)
              ], 16))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})